var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTenafiNavbarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 80,
    viewBox: "0 0 460 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: -34,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -34,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -34,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: -34,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: -22,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -22,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -22,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: -22,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: -10,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -10,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -10,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: -10,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: 2,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: 2,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 2,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: 14,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 14,
    width: 10,
    height: 9,
    rx: 1.5,
    fill: "#ffffff",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: -26,
    y1: 26,
    x2: 24,
    y2: 26,
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeLinecap: "round",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -11,
    width: 12,
    height: 11,
    rx: 3,
    fill: "#EF9F27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,-5.5 C18,-5.5 18,-26 25,-26 C32,-26 32,14 39,14 C46,14 46,-20 53,-20 C60,-20 60,-5.5 64,-5.5",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,-5.5 L88,-5.5",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: -5.5,
    r: 2.5,
    fill: "#ffffff",
    opacity: 0.4
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontFamily: "'Helvetica Neue', 'Arial', sans-serif",
    fontSize: 28,
    fontWeight: 500,
    fill: "#ffffff",
    x: 175,
    y: 48,
    textAnchor: "start",
    letterSpacing: 11
  }, "TENAFI")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenafiNavbarLogo);
export default __webpack_public_path__ + "static/media/tenafi-navbar-logo.b34b4693881d8f38651fc416694d47ca.svg";
export { ForwardRef as ReactComponent };